import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, MSALInstanceFactory } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { provideAnimations } from '@angular/platform-browser/animations';

if (environment.production) {
  enableProdMode();
}

async function bootstrap() {
  // Initialize MSAL instance BEFORE bootstrap
  const msal = MSALInstanceFactory();
  await msal.initialize();

  await bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      ...appConfig.providers,
      { provide: MSAL_INSTANCE, useValue: msal },
      provideAnimations()
    ]
  });
}

bootstrap().catch(err => console.error(err));